import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Header from "../Header";
import Card from "./Card";
import Footer from "../Footer";

const CountryCardList = () => {
    const { id } = useParams();
    const [tours, setTours] = useState([]);
    const [country, setCountry] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isScrolled, setIsScrolled] = useState(false);
    const [whatsapp, setWhatsapp] = useState('');

    useEffect(() => {
        axios.get('https://kyrgyz-adventure-travel.com/api/v1/tours/contacts')
            .then(r => { if (r.data.results.length > 0) setWhatsapp(r.data.results[0].whatsapp); })
            .catch(e => console.error(e));
    }, []);

    useEffect(() => {
        setLoading(true);
        axios.get('https://kyrgyz-adventure-travel.com/api/v1/tours/country-list')
            .then(response => {
                const foundCountry = response.data.results.find(c => c.id.toString() === id);
                if (foundCountry) {
                    setCountry(foundCountry);
                    setTours(foundCountry.tours);
                }
            })
            .catch(error => console.error('Error loading data:', error))
            .finally(() => setLoading(false));
    }, [id]);

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const bannerUrl = country?.banner?.replace(/^http:/, 'https:') || '';

    if (loading) {
        return (
            <div className="bg-dark min-h-screen flex items-center justify-center">
                <p className="font-unbounded text-white/50 text-sm">Loading...</p>
            </div>
        );
    }

    return (
        <div className="bg-dark min-h-screen">
            {/* Hero Banner */}
            <div className="relative">
                {bannerUrl && (
                    <img src={bannerUrl} alt={country?.name} className="w-full max-h-[80vh] object-cover object-bottom" />
                )}
                <div className="absolute inset-0 bg-black/30" />
                <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-dark to-transparent" />
                <Header isScrolled={isScrolled} />
                <div className="absolute bottom-16 left-0 right-0 z-10">
                    <div className="container">
                        <p className="font-unbounded text-gold text-xs uppercase tracking-widest mb-4">
                            Destination
                        </p>
                        <h1 className="font-unbounded font-bold text-5xl md:text-7xl text-white">
                            {country ? country.name : "Country not found"}
                        </h1>
                    </div>
                </div>
            </div>

            {/* Tours List */}
            <div className="container py-20">
                <div className="flex flex-col gap-4 mb-12">
                    <h2 className="font-unbounded font-bold text-3xl text-white">Available tours</h2>
                    <p className="font-manrope text-white/60">Choose the perfect tour for your adventure</p>
                </div>

                {tours.length > 0 ? (
                    <div className="flex flex-wrap gap-6">
                        {tours.map(tour => (
                            <Card key={tour.id} tour={tour} whatsapp={whatsapp} />
                        ))}
                    </div>
                ) : (
                    <div className="card-dark p-16 text-center">
                        <p className="font-manrope text-white/40 text-lg">No tours available</p>
                    </div>
                )}
            </div>

            <Footer />
        </div>
    );
};

export default CountryCardList;
